import { render, staticRenderFns } from "./EmploymentStatus2.vue?vue&type=template&id=33e0db2e&scoped=true"
import script from "./EmploymentStatus2.vue?vue&type=script&lang=js"
export * from "./EmploymentStatus2.vue?vue&type=script&lang=js"
import style0 from "./EmploymentStatus2.vue?vue&type=style&index=0&id=33e0db2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0db2e",
  null
  
)

export default component.exports